// Full-viewport populated dashboard mockup, blurred, used as the backdrop
// behind auth-flow modals (SignupPage, GhlInstallPage). Extracted verbatim
// from SignupPage 2026-07-30 (PLAN_GHL_MVP.md P1 addendum) — rendering must
// stay identical to the pre-extraction SignupPage backdrop.

const navItems = [
  { label: 'Dashboard', active: true },
  { label: 'Contacts', active: false },
  { label: 'Offline Conversions', active: false },
  { label: 'Analytics', active: false },
  { label: 'Settings', active: false },
];

const kpis = [
  { label: 'Matched contacts', value: '187', delta: '+24% this month' },
  { label: 'Won sales', value: '42', delta: '+18% this month' },
  { label: 'Revenue attributed', value: '₪24,800', delta: '+31% this month' },
];

interface Lead {
  initials: string;
  name: string;
  phone: string;
  source: string;
  campaign: string;
  status: string;
  statusBg: string;
  statusFg: string;
}

const leads: Lead[] = [
  { initials: 'DR', name: 'Daniel Rosenberg', phone: '+972 50-123-4567', source: '/images/platforms/google-ads.svg', campaign: 'summer-sandals-q3',          status: 'Won · ₪890',   statusBg: '#dcfce7', statusFg: '#166534' },
  { initials: 'MK', name: 'Maya Katz',        phone: '+972 52-987-6543', source: '/images/platforms/meta.svg',        campaign: 'ramadan-special',          status: 'New',          statusBg: '#fce7f3', statusFg: '#9d174d' },
  { initials: 'YL', name: 'Yossi Levi',       phone: '+972 54-555-1212', source: '/images/platforms/google-ads.svg', campaign: 'brand-search',             status: 'Qualified',    statusBg: '#f3e8ff', statusFg: '#6b21a8' },
  { initials: 'RB', name: 'Rachel Ben-David', phone: '+972 53-321-4321', source: '/images/platforms/meta.svg',        campaign: 'retargeting-cart-abandon', status: 'Contacted',    statusBg: '#dbeafe', statusFg: '#1e40af' },
  { initials: 'AT', name: 'Avi Tal',          phone: '+972 50-777-8888', source: '/images/platforms/whatsapp.svg',    campaign: 'organic',                  status: 'Lost',         statusBg: '#f1f5f9', statusFg: '#475569' },
  { initials: 'SE', name: 'Sara Eisenberg',   phone: '+972 58-111-2222', source: '/images/platforms/google-ads.svg', campaign: 'summer-sandals-q3',        status: 'Won · ₪1,240', statusBg: '#dcfce7', statusFg: '#166534' },
];

export function BackdropDashboard() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden>
      <div className="dashboard-mock h-full w-full flex">
        {/* Sidebar */}
        <aside className="hidden md:flex w-64 flex-col bg-white border-r border-dark/5 shrink-0">
          <div className="p-6 border-b border-dark/5">
            <span className="font-extrabold text-xl tracking-tight">
              <span style={{ WebkitTextStroke: '2px #0F172A', color: 'white', paintOrder: 'stroke fill' }}>hey</span>
              <span className="text-brand">motek</span>
            </span>
          </div>
          <nav className="flex-1 p-4 space-y-1">
            {navItems.map((item) => (
              <div
                key={item.label}
                className={`flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-semibold ${
                  item.active ? 'bg-brand text-white' : 'text-muted-foreground'
                }`}
              >
                <span className={`w-5 h-5 rounded ${item.active ? 'bg-white/30' : 'bg-muted-foreground/30'}`} />
                {item.label}
              </div>
            ))}
          </nav>
          <div className="p-4 border-t border-dark/5">
            <div className="flex items-center gap-3 rounded-lg px-4 py-3 text-muted-foreground text-sm font-medium">
              <span className="w-5 h-5 rounded bg-muted-foreground/30" />
              Logout
            </div>
          </div>
        </aside>

        {/* Main */}
        <main className="flex-1 overflow-hidden p-8">
          <h1 className="text-2xl font-bold mb-8">Dashboard</h1>

          {/* KPI cards */}
          <div className="grid grid-cols-3 gap-5 mb-8">
            {kpis.map((k) => (
              <div key={k.label} className="bg-white rounded-2xl border border-dark/5 p-6 shadow-card">
                <p className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-2">{k.label}</p>
                <p className="text-4xl font-extrabold mb-1">{k.value}</p>
                <p className="text-sm font-semibold text-green-600">{k.delta}</p>
              </div>
            ))}
          </div>

          {/* Recent contacts */}
          <div className="bg-white rounded-2xl border border-dark/5 shadow-card overflow-hidden">
            <div className="px-6 py-4 border-b border-dark/5 flex items-center justify-between">
              <h2 className="font-bold">Recent contacts</h2>
              <span className="text-sm text-muted-foreground">Last 7 days</span>
            </div>
            <div className="divide-y divide-dark/5">
              {leads.map((lead) => (
                <div key={lead.name} className="px-6 py-4 flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand/15 flex items-center justify-center text-brand font-bold text-sm">
                    {lead.initials}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm">{lead.name}</p>
                    <p className="text-xs text-muted-foreground">{lead.phone}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <img src={lead.source} alt="" className="w-5 h-5" />
                    <span className="text-xs text-muted-foreground">{lead.campaign}</span>
                  </div>
                  <span
                    className="px-3 py-1 rounded-full text-xs font-bold"
                    style={{ background: lead.statusBg, color: lead.statusFg }}
                  >
                    {lead.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>

      {/* Vignette — softens the backdrop and pops the modal */}
      <div className="absolute inset-0 vignette-overlay" />

      <style>{`
        .dashboard-mock { filter: blur(5px); }
        .vignette-overlay {
          background: radial-gradient(
            ellipse at center,
            rgba(248, 250, 252, 0.2) 0%,
            rgba(248, 250, 252, 0.55) 40%,
            rgba(248, 250, 252, 0.85) 100%
          );
        }
      `}</style>
    </div>
  );
}
